import { useEffect, useCallback } from 'react';
import { exportTaskManager, ExportTask, DownloadStatus } from '@/utils/exportTaskManager';
import useGlobalStore from '@/store/useGlobalStore';

/**
 * 导出任务管理 Hook
 * 用于在组件中管理和监听导出任务状态
 */
export const useExportTaskManager = () => {
    const { setExportTasks, setExportTasksCount } = useGlobalStore();

    // 任务状态更新回调
    const handleTasksUpdate = useCallback((tasks: ExportTask[]) => {
        // console.log('tasks', tasks);
        setExportTasks(tasks);
        const pendingCount = tasks.filter(task => task.status === 1).length;
        setExportTasksCount(pendingCount);
    }, [setExportTasks, setExportTasksCount]);

    // 组件挂载时添加监听器
    useEffect(() => {
        exportTaskManager.addListener(handleTasksUpdate);

        // 组件卸载时移除监听器
        return () => {
            exportTaskManager.removeListener(handleTasksUpdate);
        };
    }, [handleTasksUpdate]);

    // 添加导出任务
    const addExportTask = useCallback((exportKey: string, fileName: string, projectId: any) => {
        return exportTaskManager.addTask(exportKey, fileName, projectId);
    }, []);

    // 移除任务
    const removeTask = useCallback((taskId: string) => {
        exportTaskManager.removeTask(taskId);
    }, []);

    // 清除已完成的任务
    const clearCompletedTasks = useCallback(() => {
        exportTaskManager.clearCompletedTasks();
    }, []);

    // 重试下载
    const retryDownload = useCallback((taskId: string) => {
        return exportTaskManager.retryDownload(taskId);
    }, []);

    // 获取所有任务
    const getAllTasks = useCallback(() => {
        return exportTaskManager.getAllTasks();
    }, []);

    // 获取进行中的任务数量
    const getPendingTasksCount = useCallback(() => {
        return exportTaskManager.getPendingTasksCount();
    }, []);

    return {
        addExportTask,
        removeTask,
        clearCompletedTasks,
        retryDownload,
        getAllTasks,
        getPendingTasksCount
    };
};

export default useExportTaskManager;

